// config.js
export const API_URL = 'https://www.logistika.cindetemm.org.co/api/';
